// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"4b86179b","836":"5ad78bf9"}[chunkId] + ".chunk.css";
};